import { RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'
import { IStoreState, IVehicleInfo } from '../../types'
import {
  actionCreators,
  createOneVehicle,
  getSingleVehicle,
  getVehicleCreateOptions
} from '../../state/actions/vehicles'
import VehicleForm from '../../components/vehicles/VehicleForm'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<void>) {
  return {
    ...ownProps,
    organizationId: state.organizations.currentOrgId,
    createEditVehicle: state.vehicles.createEditVehicle,
    isRequesting: state.vehicles.isLoading,
    isRequestingError: state.vehicles.error,
    isDisabledToSetOwnerProvider: false,
    nextStep: '/vehicles/create/providers-and-products', // TODO Find proper to send next step's URL
    savedVehicleId: state.vehicles.savedVehicleId,
    vehicleCreateOptions: state.vehicleCreateOptions
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    createOrUpdateOne: (data: IVehicleInfo) => dispatch(createOneVehicle(data)),
    getSingleVehicle: (id: string) => dispatch(getSingleVehicle(id)),
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions()),
    setVehicleSavedStateToInitial: () => dispatch(actionCreators.setVehicleSavedStateToInitial())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleForm)



// WEBPACK FOOTER //
// ./src/containers/vehicles/CreateVehicleFormik.ts